module.exports = __webpack_public_path__ + "img/loading.7d93c2bf.png";